import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTimezone = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 23,
	viewBox: "0 0 23 23",
	fill: "#454545",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1.6271 14.1481C0.988217 11.9318 1.08842 9.56777 1.91255 7.41356C2.73669 5.25936 4.23989 3.43223 6.19474 2.20864C8.14959 0.985048 10.4497 0.431567 12.7471 0.63194C15.0445 0.832313 17.2141 1.77564 18.9277 3.31919C20.6413 4.86273 21.8056 6.92252 22.2445 9.18688C22.6834 11.4512 22.373 13.797 21.3602 15.8692C20.3474 17.9414 18.6874 19.6272 16.6313 20.6717C14.5752 21.7163 12.235 22.0625 9.96459 21.6582",
			stroke: "#454545",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.8364 1.80176V11.1959L16.6016 16.006",
			stroke: "#454545",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.21191 11.1963H3.98568",
			stroke: "#454545",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.8364 21.8226V19.0483",
			stroke: "#454545",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.687 11.1963H22.4608",
			stroke: "#454545",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.55566 3.51709L5.6843 4.82852",
			stroke: "#454545",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.2121 3.54736L18.1096 4.82841",
			stroke: "#454545",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.4082 18.6492L18.3057 17.3682",
			stroke: "#454545",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.25578 22.5127C5.121 22.6476 4.99573 22.7621 4.87256 22.8626C5.61429 22.7731 6.33242 22.4453 6.90045 21.8773C6.91293 21.8648 6.92442 21.8517 6.93677 21.8391C6.64287 21.753 6.30512 21.6844 5.94266 21.6333C5.75413 21.9484 5.52472 22.244 5.25578 22.5127Z",
			fill: "#454545"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.33101 22.7793V21.5337C3.95508 21.5378 3.58631 21.5603 3.23633 21.5994C3.40311 21.8624 3.60027 22.1106 3.82783 22.3382C4.00783 22.5183 4.16917 22.66 4.33101 22.7793Z",
			fill: "#454545"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.87256 16C4.99573 16.1007 5.121 16.2152 5.25578 16.3501C5.5246 16.6189 5.75413 16.9144 5.94253 17.2293C6.30499 17.1782 6.64275 17.1096 6.93665 17.0235C6.92442 17.0109 6.91293 16.9978 6.90045 16.9853C6.33242 16.4173 5.61429 16.0896 4.87256 16Z",
			fill: "#454545"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.33095 21.2867V19.5552H2.60449C2.62401 20.1921 2.79326 20.8089 3.09754 21.366C3.48693 21.3181 3.90165 21.291 4.33095 21.2867Z",
			fill: "#454545"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.33083 19.3079V17.5764C3.90153 17.5721 3.48681 17.545 3.09754 17.4971C2.79326 18.0542 2.62401 18.6709 2.60449 19.3079H4.33083Z",
			fill: "#454545"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.90918 19.5552H6.55173C6.53308 20.2029 6.36803 20.8303 6.07153 21.4016C6.455 21.4599 6.80795 21.5392 7.11803 21.6382C7.61923 21.0339 7.88286 20.2981 7.90918 19.5552Z",
			fill: "#454545"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.67281 21.5994C5.32282 21.5601 4.95418 21.5378 4.57812 21.5337V22.7793C4.73996 22.66 4.90118 22.5183 5.0813 22.3383C5.30886 22.1106 5.5059 21.8624 5.67281 21.5994Z",
			fill: "#454545"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.65304 16.3501C3.78795 16.2152 3.91322 16.1007 4.03638 16C3.29478 16.0896 2.57665 16.4173 2.00849 16.9853C1.99601 16.9978 1.98452 17.0109 1.97217 17.0235C2.26607 17.1096 2.60382 17.1782 2.96629 17.2293C3.15481 16.9144 3.38422 16.6189 3.65304 16.3501Z",
			fill: "#454545"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 19.308H2.35745C2.3761 18.6603 2.54115 18.0328 2.83765 17.4616C2.45418 17.4032 2.10123 17.3239 1.79114 17.2251C1.28982 17.8292 1.02631 18.5649 1 19.308Z",
			fill: "#454545"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.65304 22.5125C3.38422 22.2437 3.15481 21.9482 2.96629 21.6333C2.60382 21.6844 2.26607 21.753 1.97217 21.8391C1.9844 21.8517 1.99601 21.8648 2.00849 21.8773C2.28163 22.1504 2.58986 22.3672 2.91835 22.5297C3.27291 22.7051 3.65131 22.8161 4.03638 22.8625C3.91322 22.762 3.78795 22.6474 3.65304 22.5125Z",
			fill: "#454545"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.35745 19.5552H1C1.02631 20.2981 1.28995 21.0339 1.79114 21.6382C2.1011 21.5392 2.45406 21.4599 2.83765 21.4016C2.54115 20.8303 2.3761 20.2029 2.35745 19.5552Z",
			fill: "#454545"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.33101 17.3295V16.084C4.16917 16.2032 4.00795 16.3449 3.82783 16.525C3.60027 16.7526 3.40311 17.0008 3.23633 17.2638C3.58619 17.3029 3.95496 17.3254 4.33101 17.3295Z",
			fill: "#454545"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.55173 19.3076H7.90918C7.88286 18.5646 7.61923 17.8288 7.11803 17.2246C6.80807 17.3236 6.45512 17.4029 6.07153 17.4611C6.3679 18.0324 6.53295 18.6599 6.55173 19.3076Z",
			fill: "#454545"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.57812 17.5764V19.3079H6.30458C6.28507 18.6709 6.11582 18.0542 5.81154 17.4971C5.42214 17.545 5.00742 17.5719 4.57812 17.5764Z",
			fill: "#454545"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.57812 19.5552V21.2867C5.00742 21.291 5.42227 21.3181 5.81154 21.366C6.11582 20.8089 6.28507 20.1923 6.30458 19.5552H4.57812Z",
			fill: "#454545"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.08106 16.525C4.90094 16.3449 4.73972 16.2033 4.57788 16.084V17.3295C4.95393 17.3254 5.32257 17.3029 5.67256 17.2638C5.50591 17.0008 5.30874 16.7527 5.08106 16.525Z",
			fill: "#454545"
		})
	]
});
export default SvgTimezone;
